import gql from 'graphql-tag';

export default gql`
  fragment ClientGroupSource on ClientGroupSource {
    id
    group_id
    source_status
    source_type
    source_value
    approval
  }
`;
